module.exports = __webpack_public_path__ + "static/media/WEB19.82745d92.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/web/WEB19.jpg
// module id = 89
// module chunks = 0